import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaGithub } from "react-icons/fa6";
import ButtonIcon from './ButtonIcon';
import { GiPolarStar } from "react-icons/gi";
import { VscDebugRestart } from "react-icons/vsc";
import StarContext from "../context/StarContext";
import { HiHome } from "react-icons/hi2";
import { IoReader } from "react-icons/io5";
import { FaUserLock } from "react-icons/fa";
import { useAnalytics } from '../context/AnalyticsContext';

const NavbarWrapper = styled.nav`
  background-color: #000;
  /* background-color: rgba(0 ,0,0, 0.1);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px); */
  color: #fff;
  padding: 10px 30px;
  z-index: 1000; 
  position: fixed;
  top: 0;
  width: 100%;
`;

const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const NavbarLogo = styled.img`
  height: 30px;
`;

const NavbarLinks = styled.ul`
  list-style: none;
  display: flex;
  margin-left: auto; 
  user-select: none;
`;

const NavLink = styled(Link)`
  text-decoration: none;
  color: ${props => props.isActive ? 'var(--color-indigo-700)' : '#ddd'};
  background-color: transparent;
  margin-right: 20px;
  font-size: 18px;
  cursor: pointer;

  &:active {
    font-weight: bold; 
  }
  &:focus{
    outline: none;
  }
  &:hover {
    text-decoration: underline;
    color: var(--color-brand-700)
  }
`;

const GitHubButton = styled.button`
  text-decoration: none;
  background-color: transparent;
  padding: 5px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover{
    background-color: black;
  }
  &:focus{
    outline: none;
  }
`;


const Navbar = () => {
  const [activeLink, setActiveLink] = useState(null);
  const { isStarEnabled, setIsStarEnabled } = useContext(StarContext);
  // const location = useLocation();
  const navigate = useNavigate();
  const { trackButtonClick, trackPageClick } = useAnalytics();

  const handleStars = (event) => {
    trackButtonClick('Stars Button');
    setIsStarEnabled(prevState => !prevState);
  }

  const handleLoginButtonClick = () => {
    trackPageClick('page', 'login')
    navigate('/login');
  }

  const handleGitHubButtonClick = () => {
    // Track button click event using Google Analytics
    trackButtonClick('GitHub Button');

    // Navigate to the GitHub link after tracking the event
    window.open("https://github.com/ksachin7", '_blank');
  };
  
  const handleLinkClick = (link) => {
    trackPageClick('page', 'blogs')
    setActiveLink(link);
  };

  return (
    <NavbarWrapper>
      <NavbarContainer>
        <NavbarLogo src="/logo.png" alt="Sachin" />
        <NavbarLinks>
          <NavLink
            to="/"
            isActive={activeLink === '/home'}
            onClick={() => handleLinkClick('/home')}
          >
            {/* <ButtonIcon> */}
            {/* <HiHome /> */}
            <span>Home</span>
            {/* </ButtonIcon> */}
          </NavLink>
          {/* <NavLink to="/photos">Photos</NavLink> */}
          <NavLink
            to="/blogs"
            isActive={activeLink === '/blogs'}
            onClick={() => handleLinkClick('/blogs')}
          >
            {/* <ButtonIcon> */}
            {/* <IoReader /> */}
            <span>Blogs</span>
            {/* </ButtonIcon> */}
          </NavLink>
        </NavbarLinks>
        <ButtonIcon hcolor='#3730a3' onClick={handleLoginButtonClick}>
            <FaUserLock size={24} />
          </ButtonIcon>
        {/* {location.pathname === '/blogs' ? (
          <ButtonIcon onClick={handleLoginButtonClick}>
            <FaUserLock color='silver' size={24} />
          </ButtonIcon>
        ) : (
          <ButtonIcon onClick={handleStars}>
            {isStarEnabled ? <VscDebugRestart /> : <GiPolarStar />}
          </ButtonIcon>
        )} */}
        <GitHubButton onClick={handleGitHubButtonClick}>
          <FaGithub color='silver' size={30} />
        </GitHubButton>
      </NavbarContainer>
    </NavbarWrapper>
  );
};

export default Navbar;
